import axios from "axios";
import { base_url } from "../../utils/baseUrl";

const getToken = () => {
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;
  return user?.data?.token || null;
};

const getAuthHeaders = () => {
  const token = getToken();
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

const getImageFeeds = async () => {
  const response = await axios.get(`${base_url}image-feed/all`, getAuthHeaders());
  return response.data;
};

const createImageFeed = async (formData) => {
  const token = getToken();
  const response = await axios.post(`${base_url}image-feed/add`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};

const getAImageFeed = async (id) => {
  const response = await axios.get(`${base_url}image-feed/get/${id}`, getAuthHeaders());
  return response.data;
};

const deleteImageFeed = async (id) => {
  const response = await axios.delete(`${base_url}image-feed/delete/${id}`, getAuthHeaders());
  return response.data;
};

const updateImageFeed = async (payload) => {
  const token = getToken();
  const response = await axios.put(
    `${base_url}image-feed/update/${payload.id}`,
    payload.feedData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

const imageFeedService = {
  getImageFeeds,
  createImageFeed,
  getAImageFeed,
  deleteImageFeed,
  updateImageFeed,
};

export default imageFeedService;
